import toast from 'react-hot-toast';

interface EmailNotificationProps {
  title: string;
  body: string;
  folder: string;
  newCount: string;
  totalCount: string;
  email_id: string;
  email_uid: string;
}

export const showEmailNotification = ({ title, body }: EmailNotificationProps) => {
  return toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-gray-900 shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-white/10`}
        onClick={() => {
          // Navigate to the email when clicked
          // window.location.href = `/email/${folder}/${email_id}/${email_uid}`;
          toast.dismiss(t.id);
        }}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex items-start">
            <div className="ml-3 flex-1">
              <p className="text-sm font-medium text-white">{title}</p>
              <p className="mt-1 text-sm text-gray-400">{body}</p>
            </div>
          </div>
        </div>
        <div className="flex border-l border-gray-700">
          <button
            onClick={(e) => {
              e.stopPropagation();
              toast.dismiss(t.id);
            }}
            className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-blue-400 hover:text-blue-300 focus:outline-none"
          >
            Close
          </button>
        </div>
      </div>
    ),
    {
      position: 'bottom-left',
      duration: 5000,
    }
  );
};